import {
  ADD_APPOINTMENT,
  RESET_ADD_APPOINTMENT,
  APPOINTMENT_FORM,
  APPOINTMENT_FORM_UPDATE,
  EDIT_APPOINTMENT,
  GET_APPOINTMENT_DETAIL,
  GET_APPOINTMENT_LIST,
  GET_CLIENT_VISIT,
  GET_COMPLETE_STATUS,
  GET_CONFIRM_STATUS,
  GET_PANDING_STATUS,
  GET_SITE_LEAD_VISIT,
  GET_VISITOR_LIST,
  GET_APPOINTMENT_LIST_ADMIN,
  CHECKIN_APPOINTMENT,
  CLOSE_APPOINTMENT,
  ALLOCATE_CLOSING_MANAGER
} from "../types";

const initialState = {
  response: null,
  response1:null,
  addResponse:null,
  loading: true,
  create: false,
  detail: false,
};
const initialStateSiteLeadVisit = {
  response: null,
  loading: true
}
const initialStateClientVisit = {
  response: null,
  loading: true
}
const initialStatePandingStatus = {
  response: null,
  loading: true
}
const initialStateConfirmStatus = {
  response: null,
  loading: true
}
const initialStateCompleteStatus = {
  response: null,
  loading: true
}
const initialStateForm = {
  response: null,
  update: false,
};

const initialCheckinState = {
  response: null,
  detail: false,
  create: false,
}

const initialAssignState = {
  response: null,
  update: false,
}

export default function appointmentStore(state = initialState, action) {
  switch (action.type) {
    case GET_APPOINTMENT_LIST:
      return {
        ...state,
        create: false,
        detail: false,
        response: action.payload,
      };
    case GET_APPOINTMENT_DETAIL:
      return {
        ...state,
        create: false,
        detail: true,
        response: action.payload,
      };
    case EDIT_APPOINTMENT:
      return {
        ...state,
        create: true,
        detail: false,
        response: action.payload,
      };
    case GET_VISITOR_LIST:
      return {
        ...state,
        create: false,
        detail: false,
        response: action.payload,
      };
    case ADD_APPOINTMENT:
      return {
        ...state,
        detail: false,
        create: true,
        addResponse: action.payload,
      };
    // JUSTO-88: Clear add-appointment state after successful create so redirect works and duplicate submit is prevented.
    case RESET_ADD_APPOINTMENT:
      return {
        ...state,
        create: false,
        addResponse: null,
      };
    case GET_APPOINTMENT_LIST_ADMIN:
        return {
          ...state,
          create: false,
          detail: false,
          response1: action.payload,
        };
      case CLOSE_APPOINTMENT:
          return {
            ...state,
            detail: false,
            create: true,
            response: action.payload,
          };

    default:
      return state;
  }
}
export function siteLeadVisitReducer(state = initialStateSiteLeadVisit, action) {
  switch (action.type) {
    case GET_SITE_LEAD_VISIT:
      return {
        ...state,
        loading: false,
        response: action.payload,
      }
    default: return state
  }
}
export function clientVisitReducer(state = initialStateClientVisit, action) {
  switch (action.type) {
    case GET_CLIENT_VISIT:
      return {
        ...state,
        loading: false,
        response: action.payload,
      }
    default: return state
  }
}
export function pandingStatusReducer(state = initialStatePandingStatus, action) {
  switch (action.type) {
    case GET_PANDING_STATUS:
      return {
        ...state,
        loading: false,
        response: action.payload,
      }
    default: return state
  }
}
export function confirmStatusReducer(state = initialStateConfirmStatus, action) {
  switch (action.type) {
    case GET_CONFIRM_STATUS:
      return {
        ...state,
        loading: false,
        response: action.payload,
      }
    default: return state
  }
}
export function completeStatusReducer(state = initialStateCompleteStatus, action) {
  switch (action.type) {
    case GET_COMPLETE_STATUS:
      return {
        ...state,
        loading: false,
        response: action.payload,
      }
    default: return state
  }
}

export function appointmentFormReducer(state = initialStateForm, action) {
  switch (action.type) {
    case APPOINTMENT_FORM:
      return {
        ...state,
        update: false,
        response: action.payload,
      };
    case APPOINTMENT_FORM_UPDATE:
      return {
        ...state,
        update: true,
        response: action.payload,
      };

    default:
      return state;
  }
}

export function appointmentCheckinReducer(state = initialCheckinState, action) {
  switch (action.type) {
    case CHECKIN_APPOINTMENT:
      return {
        ...state,
        response: action.payload,
        loading: false,
      };

    default:
      return state;
  }
}

export function assignClosingManagerStore(state = initialAssignState, action) {
  switch (action.type) {
    case ALLOCATE_CLOSING_MANAGER:
      return {
        ...state,
        response: action.payload,
        loading: false,
      };

    default:
      return state;
  }
}

